export var DominioRewardsAction;
(function (DominioRewardsAction) {
    DominioRewardsAction["CLICK_SIDENAV"] = "pgm_pontos_click_sidenav";
    DominioRewardsAction["CLICK_CARD"] = "pgm_pontos_click_card";
    DominioRewardsAction["VIEW_BANNER"] = "pgm_pontos_view_banner";
    DominioRewardsAction["CLICK_ACTIVATE"] = "pgm_pontos_botao_ativar";
    DominioRewardsAction["CLICK_LEARN_MORE"] = "pgm_pontos_botao_saiba_mais";
    DominioRewardsAction["CLICK_ACCOUNTING"] = "pgm_pontos_contabilidade";
    DominioRewardsAction["CLICK_REFER_ACCOUNT"] = "pgm_pontos_indique_conta";
    DominioRewardsAction["CLICK_REFER_BENEFITS"] = "pgm_pontos_indicacao_beneficios";
    DominioRewardsAction["CLICK_REFER_BILLING"] = "pgm_pontos_indicacao_cobran\u00E7as";
    DominioRewardsAction["CLICK_REDEEM"] = "pgm_pontos_botao_resgatar_saldo";
    DominioRewardsAction["VIEW_REDEEM_VALUE"] = "pgm_pontos_view_valor_resgate";
    DominioRewardsAction["CLICK_NEXT_VALUE"] = "pgm_pontos_botao_valor_resgate";
    DominioRewardsAction["VIEW_REDEEM_INVOICE"] = "pgm_pontos_view_nota_resgate";
    DominioRewardsAction["CLICK_NEXT_INVOICE"] = "pgm_pontos_botao_nota_resgate";
    DominioRewardsAction["VIEW_REDEEM_REVIEW"] = "pgm_pontos_view_revisao_resgate";
    DominioRewardsAction["CLICK_CONFIRM_REDEEM"] = "pgm_pontos_botao_revisao_resgate";
})(DominioRewardsAction || (DominioRewardsAction = {}));
